module.exports = __webpack_public_path__ + "img/despacho1.e7f62f3e.png";